const PricingStudio = () => {

  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        PricingStudio
      </div>
    </div>
  )
}
export default PricingStudio